module.exports = __webpack_public_path__ + "static/media/homelogo.1d941308.png";